import React, { useEffect, useState } from "react";
import Loading from "../Modals/Loading";
import { useNavigate } from "react-router-dom";
import warehouseService from "../Services/warehouseService";
import Head from "../Components/Head";
import { LuEye } from "react-icons/lu";
import { HiOutlineTrash } from "react-icons/hi";
import { FiEdit3 } from "react-icons/fi";

const Warehouse = () => {
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const getWarehouses = async () => {
      try {
        setLoading(true);
        const response = await warehouseService.fetchAll();
        setWarehouses(response.warehouses);
        setLoading(false);
      } catch {}
    };
    getWarehouses();
  }, []);

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <Head
        heading={"Warehouse"}
        button_text={"Add Warehouse"}
        navigation={() => navigate("/warehouse/add")}
      />
      {loading ? (
        <Loading />
      ) : (
        <div>
          {/* Table */}
          {warehouses && warehouses.length > 0 ? (
            <div className="table-div">
              <table className="w-full">
                <thead className="border-y-2 text-left text-black text-[10px]">
                  <tr>
                    <th className="text-center py-4 w-[4%] rounded-tl-lg">
                      Sr No.
                    </th>
                    <th className="text-center py-4 w-[4%]">Name</th>
                    <th className="text-center py-4 w-[1%]">Location</th>
                    <th className="text-center py-4 w-[6%]">Area</th>
                    <th className="text-center py-4 w-[4%]">Edit</th>
                    <th className="text-center py-4 w-[4%] rounded-tr-lg">
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {warehouses.map((value, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-100 text-center"
                    >
                      <td className="py-4 text-blue-500 font-bold">
                        {index + 1}
                      </td>
                      <td className="py-4 w-[4%]">{value.name}</td>
                      <td className="py-4 w-[5%]">{value.location}</td>
                      <td className="py-4 font-bold w-[6%]">{value.area}</td>
                      <td className="py-4 w-[2%]">
                        <div className="flex justify-center gap-4">
                          <button>
                            <FiEdit3 className="text-base text-blue-500" />
                          </button>
                          <button>
                            <HiOutlineTrash className="h-4 w-4 text-red-500" />
                          </button>
                        </div>
                      </td>
                      <td className="py-4 text-[12px] w-[4%]">
                        <button>
                          <LuEye className="h-4 w-4 text-sky-600" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">
                No Data Found
              </h1>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default Warehouse;
